<ng-container *transloco="let t; read: 'applicationsPanel'">
  <elm-app-action-card *ngIf="row.elements.applicationsPanel !== false">
    <ng-container *ngIf="loaded$ | async; else loadingTpl">
      <h1 class="elm-app-action-title elm-spacing-m">{{ t('welcomeBack', { firstName: firstName$ | async }) }}</h1>
      <p *ngIf="hasApplications$ | async" class="elm-app451-body-1 elm-spacing-l current-applications">
        {{ t('yourApplications') }}
      </p>

      <elm-app-application-list class="elm-spacing-l">
        <button
          elm-app-application-list-item
          *ngFor="let application of list$ | async; trackBy: trackByApplication"
          [application]="application"
          [routerLink]="['dashboard', application.registration_id]"
        ></button>
      </elm-app-application-list>

      <p class="elm-fg-warn" *ngIf="applicationRegistrationErrorMessage$ | async as errorMessage">{{ errorMessage }}</p>

      <ng-container *ngIf="row.elements.startApplicationAfterLogin !== false">
        <p class="elm-app451-body-1 elm-spacing-l">{{ t('startNewApplication') }}</p>

        <button (click)="onStartApplication()" class="elm-app451-btn-wide-xl elm-dynamic-bg-primary">
          <span ngClass.xs="elm-app451-btn-label-l" ngClass.gt-xs="elm-app451-btn-label-xl">{{
            t('startNewApplicationBtn')
          }}</span>
        </button>
      </ng-container>
    </ng-container>
  </elm-app-action-card>

  <ng-template #loadingTpl>
    <ng-container *ngIf="loading$ | async; else fatalErrorTpl">
      <elm-progress-spinner mode="indeterminate" size="x-large">
        <p class="elm-app451-body-1 elm-no-margin">{{ t('loading') }}</p>
      </elm-progress-spinner>
    </ng-container>
  </ng-template>

  <ng-template #fatalErrorTpl>
    <elm-empty-state icon="report-problem-triangle" [title]="t('error.title')" [message]="t('error.message')">
    </elm-empty-state>
  </ng-template>
</ng-container>
